import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

export const campaignStatsHourlyItemSchema = z.object({
  hour: z.number().optional(),
  weekday: z.number().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  impressions: z.number().nullable().optional(),
  clicks: z.number().nullable().optional(),
  cost: z.number().nullable().optional(),
  click_thru_rate: z.number().nullable().optional(),
  conv_rate: z.number().nullable().optional(),
  conversion: z.number().nullable().optional(),
  ad_sales: z.number().nullable().optional(),
  ad_spend: z.number().nullable().optional(),
  roas: z.number().nullable().optional(),
  acos: z.number().nullable().optional(),
  cost_per_click: z.number().nullable().optional(),
});

export const campaignStatsHourlyApiDefinitions = prefixApi(
  "/api/data_report_v2/campaignstatshourly",
  apiBuilder({
    alias: "getCampaignStatsHourly",
    method: "get",
    path: "/stats/",
    status: 200,
    parameters: [
      {
        name: "dimensions",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "filters",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    response: z.array(campaignStatsHourlyItemSchema),
  }).build(),
);
